import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Switch } from './ui/switch';
import { Label } from './ui/label';
import { api } from '../lib/api';
import { useLang } from '../contexts/LanguageContext';

// Fix 36 (2026-09-17): switch de autocompletado de compradores ya conocidos.
// Apagado = el sistema se comporta exactamente como antes.
export default function KnownBuyerAutoFillSwitch() {
  const { t } = useLang();
  const qc = useQueryClient();

  const q = useQuery({
    queryKey: ['auto-fill-known-buyers'],
    queryFn: async () => (await api.get('/admin/auto-fill-known-buyers')).data,
    staleTime: 10000,
  });

  const m = useMutation({
    mutationFn: async (active) =>
      (await api.post('/admin/auto-fill-known-buyers', null, { params: { active } })).data,
    onSuccess: (data) => {
      toast.success(data.active
        ? t('manual_review.autofill_on')
        : t('manual_review.autofill_off'));
      qc.invalidateQueries({ queryKey: ['auto-fill-known-buyers'] });
      qc.invalidateQueries({ queryKey: ['manual-review'] });
    },
    onError: () => toast.error(t('manual_review.autofill_error')),
  });

  const active = !!q.data?.active;

  return (
    <div
      className="flex items-center gap-2 rounded-md border border-border px-3 py-1.5"
      title={t('manual_review.autofill_help')}
      data-testid="known-buyer-autofill-switch"
    >
      <Switch
        checked={active}
        disabled={q.isLoading || m.isPending}
        onCheckedChange={(v) => m.mutate(!!v)}
        data-testid="known-buyer-autofill-toggle"
      />
      <Label className="text-[12px] cursor-pointer leading-tight">
        {t('manual_review.autofill_label')}
      </Label>
    </div>
  );
}
